export const COMMISSION_DEFAULT_PORTFOLIO = 0.005;
export const COMMISSION_DEFAULT_AGIO = 0.05;
export const CB_50_REFUND = 0.5;
export const CB_100_FEE = 15 * 12;
export const CB_80_REFUND = 0.8;

export const DEFAULT_BIC = 'COBADEHDXXX';

export type CashbackModel = 'flat-fee' | '80-percent';
